import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList
} from 'recharts';

import s from './styles/avitoStats.module.css'; // путь должен быть актуален
import { RUBLE_METRIC, BONUS_METRIC, PERCENT_METRICS } from './metricsConfig';



const MetricGraph = ({ label, data, color, average, ruble, bonus, percent, totalConversion, total, slave_metrica, slave_total}) => {
    if (!data) return null;
  
    const flatData = Object.entries(data)
    .flatMap(([month, values]) =>
      values.map(item => ({
        ...item,
        name: item.date,
        month,
      }))
    )
    .sort((a, b) => new Date(a.full_date) - new Date(b.full_date));
  
    const monthLabel = Array.from(new Set(flatData.map(d => d.month))).join(' – ');

    const isSlaveRuble = !!RUBLE_METRIC[slave_metrica];
    const isSlaveBonus = !!BONUS_METRIC[slave_metrica];
    const isSlavePercent = !!PERCENT_METRICS[slave_metrica];


    const CustomTick = ({ x, y, payload, index }) => {
        const { value } = payload;
        const d = flatData[index]; // доступ к дню и дню недели
        if (!d) return null;
      
        const day = d.date.split('.')[0];
        const weekday = d.weekday;
      
        return (
          <g transform={`translate(${x},${y + 10})`}>
            <text textAnchor="middle" fontSize={8} fill="#666">
              <tspan x={0} dy="-0.5em">{day}</tspan>
              <tspan x={0} dy="1.2em">{weekday}</tspan>
            </text>
          </g>
        );
      };


    return (
      <div className={s.chartContainer}>
        <div className={s.chartHeader}>
          <span className={s.chartTitle}>{label}</span>
          <div>

          <span className={s.chartSlaveTotal}>
            {slave_total !== undefined && slave_total !== null
              ? `${slave_total.toFixed(2).replace('.', ',')}${isSlaveRuble ? ' ₽ | ' : ''}${isSlaveBonus ? ' Б | ' : ''}${isSlavePercent ? ' % | ' : ''}`
              : null}
          </span>

          <span className={s.chartTotal}>{total !== undefined && total !== null
              ? `${total.toFixed(2).replace('.', ',')}${ruble ? ' ₽' : ''}${bonus ? ' Б' : ''}${percent ? ' %' : ''}`
              :totalConversion !== undefined && totalConversion !== null
              ? `${totalConversion.toFixed(2).replace('.', ',')}${percent ? ' %' : ''}`
              : average
                ? (() => {
                    const nonZero = flatData.filter(d => d.value > 0);
                    const avg = nonZero.length
                      ? nonZero.reduce((sum, d) => sum + d.value, 0) / nonZero.length
                      : 0;
                    return `${avg.toFixed(2).replace('.', ',')}${ruble ? ' ₽' : ''}${bonus ? ' Б' : ''}${percent ? ' %' : ''}`;
                  })()
                : `${flatData.reduce((sum, d) => sum + d.value, 0).toLocaleString('ru-RU')}${ruble ? ' ₽' : ''}${bonus ? ' Б' : ''}${percent ? ' %' : ''}`}
          </span>
                      
          </div>
        </div>
  
        <ResponsiveContainer width="100%" height={80}>
          <BarChart data={flatData}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          >
          <XAxis
            dataKey="name"
            tick={CustomTick}
            interval={0}
            height={35}
            axisLine={false}  // ❌ убирает линию оси X
            tickLine={false}  // ❌ убирает "черточки" у каждой метки
            padding={{ right: 0, left: 0 }}
          />
            <YAxis axisLine={false} tickLine={false} />
            <Tooltip formatter={(val) => [val, label]} />
            <Bar dataKey="value" fill={Array.isArray(color) ? color[0] : color} radius={[6, 6, 6, 6]}>
            
              {/* <LabelList dataKey="value" position="top" /> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <div className={s.monthLabel}>{monthLabel}</div>
      </div>
    );
  };
  export { MetricGraph };